import React from 'react';
import { ParticipantStep } from '../../../../../../types/v3Types';
import { ButtonNames } from '../../../../../../contexts/main/biInterfaces';
import { SidebarLayoutButton } from '../../../components/Buttons/SidebarLayoutButton/SidebarLayoutButton';
import {
  getFlatStepsList,
  getNextStepToComplete,
  getProgramProgress,
} from '../../utils';
import { Props } from '../interfaces';

export interface StartButtonProps {
  props: Props;
  getIsStartDisabled: () => boolean;
  setStep: (currentStep: ParticipantStep) => void;
  sendBiButtonClick: (buttonName: ButtonNames, step?: string) => void;
}

export const StartButton: React.FC<StartButtonProps> = ({
  props,
  getIsStartDisabled,
  setStep,
  sendBiButtonClick,
}) => {
  const { t } = props;
  const flatStepsList = getFlatStepsList(props);
  const { isProgramNotStarted } = getProgramProgress(flatStepsList);

  return (
    <SidebarLayoutButton
      disabled={getIsStartDisabled()}
      onClick={() => {
        const nextStepToComplete = getNextStepToComplete(flatStepsList);
        if (nextStepToComplete) {
          setStep(nextStepToComplete);
        }

        sendBiButtonClick(ButtonNames.OverviewStartButton);
      }}
    >
      {isProgramNotStarted
        ? t('challenge.page.overview.start-btn')
        : t('challenge.page.overview.current-step')}
    </SidebarLayoutButton>
  );
};
